/**
 * DASHBOARD-RPS-GOLLAC-OVERVIEW-SKELETON.WIDGET
 * Skeleton adapté à dashboard-rps-gollac-overwiew.widget.tsx : paragraphes de texte à
 * gauche, graphique de répartition à droite (réutilise DashboardRepartitionSkeletonWidget,
 * même forme que dashboard-repartition-chart.widget.tsx), avec un reflet qui balaie.
 */
import Skeleton, { SkeletonShine } from "@/components/skeleton"
import DashboardRepartitionSkeletonWidget from "./dashboard-repartition-skeleton.widget"

export default function DashboardRpsGollacOverviewSkeletonWidget() {
  return (
    <div className="rel flex" style={{ overflow: "hidden", gap: 35 }}>
      <div className="flex flex-col justify-center" style={{ gap: 10, flex: 1 }}>
        <Skeleton width="90%" height={13} />
        <Skeleton width="75%" height={13} />
        <Skeleton width="85%" height={13} style={{ marginTop: 8 }} />
        <Skeleton width="60%" height={13} />
      </div>

      <div style={{ flex: 1 }}>
        <DashboardRepartitionSkeletonWidget showSummary />
      </div>

      <SkeletonShine />
    </div>
  )
}
